import { t } from 'i18next'
import { Highlight, connectRefinementList } from 'react-instantsearch-dom'

import pageLanguage from '../../functions/pageLanguage'
import './Colors.scss'

const highlightStyle = {
  backgroundColor: 'rgba(0, 140, 255, 0.1)',
  color: '#008CFF',
  border: '1px solid #008CFF',
  width: '70%',
  borderRadius: '36px',
  paddingTop: '5px',
  paddingBottom: '5px',
  boxSizing: 'border-box'
}

const normalStyle = {
  backgroundColor: '#FFFFFF',
  color: '#232A2D',
  border: 'none',
  paddingTop: '2px',
  paddingBottom: '2px'
}

const lang = pageLanguage()

const RefinementList = ({
  items,
  isFromSearch,
  refine,
  createURL,
}: {
  items: any
  isFromSearch: any
  refine: any
  createURL: any
}) => (
  <div className="colors_container">
    <div className="colorsLabel">{t('colours')}</div>
    <ul className="colors">
      {items.map((item: any) => {
        const color = item.label.split(":")

        return (
          <li
            key={item.value}
            className="colorOption"
            style={item.isRefined ? highlightStyle : normalStyle}
          >
            <a
              href={createURL(item.value)}
              onClick={event => {
                event.preventDefault()
                refine(item.value)
              }}
            >
              {isFromSearch ? (
                <Highlight attribute="label" hit={item} />
              ) : (
                <>
                  <div
                    className="color"
                    style={{ backgroundColor: color[0] }}
                  ></div>

                  <div className="colorName">
                    {lang === "ar" ? color[2] : color[1]}
                  </div>
                </>
              )}
            </a>
          </li>
        )
      })}
    </ul>

  </div>
)

const Colors = connectRefinementList(RefinementList)


export default Colors